module.exports = __webpack_public_path__ + "img/security.b1ccb12b.png";